/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Api
 * BMC Hiring Tool API
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AcceptDetail,
  AuthResult,
  BulkSendOffersBody,
  BulkSendOffersResult,
  Campaign,
  CampaignBody,
  CampaignDetail,
  CampaignSummary,
  CreatorSearchResult,
  ErrorResponse,
  FindCreatorsParams,
  FollowUpBody,
  HealthStatus,
  LoginBody,
  Offer,
  ResendResult,
  SendFollowUp200,
  SendOfferBody,
  SetCreatorPreference200,
  SetCreatorPreferenceBody,
  UpdateOfferBody,
} from "./api.schemas";

import { customFetch } from "../custom-fetch";
import type { ErrorType, BodyType } from "../custom-fetch";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Health check
 */
export const getHealthCheckUrl = () => {
  return `/api/healthz`;
};

export const healthCheck = async (
  options?: RequestInit,
): Promise<HealthStatus> => {
  return customFetch<HealthStatus>(getHealthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getHealthCheckQueryKey = () => {
  return [`/api/healthz`] as const;
};

export const getHealthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({
    signal,
  }) => healthCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type HealthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof healthCheck>>
>;
export type HealthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Health check
 */

export function useHealthCheck<
  TData = Awaited<ReturnType<typeof healthCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof healthCheck>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getHealthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Login with shared password
 */
export const getAuthLoginUrl = () => {
  return `/api/auth/login`;
};

export const authLogin = async (
  loginBody: LoginBody,
  options?: RequestInit,
): Promise<AuthResult> => {
  return customFetch<AuthResult>(getAuthLoginUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(loginBody),
  });
};

export const getAuthLoginMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authLogin>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authLogin>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  const mutationKey = ["authLogin"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authLogin>>,
    { data: BodyType<LoginBody> }
  > = (props) => {
    const { data } = props ?? {};

    return authLogin(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthLoginMutationResult = NonNullable<
  Awaited<ReturnType<typeof authLogin>>
>;
export type AuthLoginMutationBody = BodyType<LoginBody>;
export type AuthLoginMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Login with shared password
 */
export const useAuthLogin = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authLogin>>,
    TError,
    { data: BodyType<LoginBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof authLogin>>,
  TError,
  { data: BodyType<LoginBody> },
  TContext
> => {
  return useMutation(getAuthLoginMutationOptions(options));
};

/**
 * @summary Check if authenticated
 */
export const getAuthCheckUrl = () => {
  return `/api/auth/check`;
};

export const authCheck = async (options?: RequestInit): Promise<AuthResult> => {
  return customFetch<AuthResult>(getAuthCheckUrl(), {
    ...options,
    method: "GET",
  });
};

export const getAuthCheckQueryKey = () => {
  return [`/api/auth/check`] as const;
};

export const getAuthCheckQueryOptions = <
  TData = Awaited<ReturnType<typeof authCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof authCheck>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthCheckQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof authCheck>>> = ({
    signal,
  }) => authCheck({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof authCheck>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type AuthCheckQueryResult = NonNullable<
  Awaited<ReturnType<typeof authCheck>>
>;
export type AuthCheckQueryError = ErrorType<unknown>;

/**
 * @summary Check if authenticated
 */

export function useAuthCheck<
  TData = Awaited<ReturnType<typeof authCheck>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<Awaited<ReturnType<typeof authCheck>>, TError, TData>;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getAuthCheckQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Logout
 */
export const getAuthLogoutUrl = () => {
  return `/api/auth/logout`;
};

export const authLogout = async (
  options?: RequestInit,
): Promise<AuthResult> => {
  return customFetch<AuthResult>(getAuthLogoutUrl(), {
    ...options,
    method: "POST",
  });
};

export const getAuthLogoutMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authLogout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof authLogout>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ["authLogout"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof authLogout>>,
    void
  > = () => {
    return authLogout(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthLogoutMutationResult = NonNullable<
  Awaited<ReturnType<typeof authLogout>>
>;

export type AuthLogoutMutationError = ErrorType<unknown>;

/**
 * @summary Logout
 */
export const useAuthLogout = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof authLogout>>,
    TError,
    void,
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof authLogout>>,
  TError,
  void,
  TContext
> => {
  return useMutation(getAuthLogoutMutationOptions(options));
};

/**
 * @summary List all campaigns with offer counts
 */
export const getListCampaignsUrl = () => {
  return `/api/v1/hiring/campaigns`;
};

export const listCampaigns = async (
  options?: RequestInit,
): Promise<CampaignSummary[]> => {
  return customFetch<CampaignSummary[]>(getListCampaignsUrl(), {
    ...options,
    method: "GET",
  });
};

export const getListCampaignsQueryKey = () => {
  return [`/api/v1/hiring/campaigns`] as const;
};

export const getListCampaignsQueryOptions = <
  TData = Awaited<ReturnType<typeof listCampaigns>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCampaigns>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListCampaignsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listCampaigns>>> = ({
    signal,
  }) => listCampaigns({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listCampaigns>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ListCampaignsQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCampaigns>>
>;
export type ListCampaignsQueryError = ErrorType<unknown>;

/**
 * @summary List all campaigns with offer counts
 */

export function useListCampaigns<
  TData = Awaited<ReturnType<typeof listCampaigns>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: UseQueryOptions<
    Awaited<ReturnType<typeof listCampaigns>>,
    TError,
    TData
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getListCampaignsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Create a new campaign
 */
export const getCreateCampaignUrl = () => {
  return `/api/v1/hiring/campaigns`;
};

export const createCampaign = async (
  campaignBody: CampaignBody,
  options?: RequestInit,
): Promise<Campaign> => {
  return customFetch<Campaign>(getCreateCampaignUrl(), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(campaignBody),
  });
};

export const getCreateCampaignMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCampaign>>,
    TError,
    { data: BodyType<CampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCampaign>>,
  TError,
  { data: BodyType<CampaignBody> },
  TContext
> => {
  const mutationKey = ["createCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCampaign>>,
    { data: BodyType<CampaignBody> }
  > = (props) => {
    const { data } = props ?? {};

    return createCampaign(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCampaign>>
>;
export type CreateCampaignMutationBody = BodyType<CampaignBody>;
export type CreateCampaignMutationError = ErrorType<unknown>;

/**
 * @summary Create a new campaign
 */
export const useCreateCampaign = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCampaign>>,
    TError,
    { data: BodyType<CampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof createCampaign>>,
  TError,
  { data: BodyType<CampaignBody> },
  TContext
> => {
  return useMutation(getCreateCampaignMutationOptions(options));
};

/**
 * @summary Get campaign detail with all offers
 */
export const getGetCampaignUrl = (id: string, page?: number, status?: string, search?: string) => {
  const params = new URLSearchParams();
  if (page && page > 1) params.set("page", String(page));
  if (status && status !== "all") params.set("status", status);
  if (search) params.set("search", search);
  const qs = params.toString();
  return `/api/v1/hiring/campaigns/${id}${qs ? `?${qs}` : ""}`;
};

export const getCampaign = async (
  id: string,
  page?: number,
  status?: string,
  search?: string,
  options?: RequestInit,
): Promise<CampaignDetail> => {
  return customFetch<CampaignDetail>(getGetCampaignUrl(id, page, status, search), {
    ...options,
    method: "GET",
  });
};

export const getGetCampaignQueryKey = (id: string, page?: number, status?: string, search?: string) => {
  return [
    `/api/v1/hiring/campaigns/${id}`,
    ...(page ? [{ page }] : []),
    ...(status && status !== "all" ? [{ status }] : []),
    ...(search ? [{ search }] : []),
  ] as const;
};

export const getGetCampaignQueryOptions = <
  TData = Awaited<ReturnType<typeof getCampaign>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  page?: number,
  status?: string,
  search?: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCampaign>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCampaignQueryKey(id, page, status, search);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCampaign>>> = ({
    signal,
  }) => getCampaign(id, page, status, search, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCampaign>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetCampaignQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCampaign>>
>;
export type GetCampaignQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get campaign detail with all offers
 */

export function useGetCampaign<
  TData = Awaited<ReturnType<typeof getCampaign>>,
  TError = ErrorType<ErrorResponse>,
>(
  id: string,
  page?: number,
  status?: string,
  search?: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getCampaign>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetCampaignQueryOptions(id, page, status, search, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Update a campaign
 */
export const getUpdateCampaignUrl = (id: string) => {
  return `/api/v1/hiring/campaigns/${id}`;
};

export const updateCampaign = async (
  id: string,
  campaignBody: CampaignBody,
  options?: RequestInit,
): Promise<Campaign> => {
  return customFetch<Campaign>(getUpdateCampaignUrl(id), {
    ...options,
    method: "PUT",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(campaignBody),
  });
};

export const getUpdateCampaignMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCampaign>>,
    TError,
    { id: string; data: BodyType<CampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateCampaign>>,
  TError,
  { id: string; data: BodyType<CampaignBody> },
  TContext
> => {
  const mutationKey = ["updateCampaign"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCampaign>>,
    { id: string; data: BodyType<CampaignBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateCampaign(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateCampaignMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCampaign>>
>;
export type UpdateCampaignMutationBody = BodyType<CampaignBody>;
export type UpdateCampaignMutationError = ErrorType<unknown>;

/**
 * @summary Update a campaign
 */
export const useUpdateCampaign = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateCampaign>>,
    TError,
    { id: string; data: BodyType<CampaignBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateCampaign>>,
  TError,
  { id: string; data: BodyType<CampaignBody> },
  TContext
> => {
  return useMutation(getUpdateCampaignMutationOptions(options));
};

/**
 * @summary Search and filter creator roster
 */
export const getFindCreatorsUrl = (id: string, params?: FindCreatorsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : value.toString());
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `/api/v1/hiring/campaigns/${id}/find?${stringifiedParams}`
    : `/api/v1/hiring/campaigns/${id}/find`;
};

export const findCreators = async (
  id: string,
  params?: FindCreatorsParams,
  options?: RequestInit,
): Promise<CreatorSearchResult> => {
  return customFetch<CreatorSearchResult>(getFindCreatorsUrl(id, params), {
    ...options,
    method: "GET",
  });
};

export const getFindCreatorsQueryKey = (
  id: string,
  params?: FindCreatorsParams,
) => {
  return [`/api/v1/hiring/campaigns/${id}/find`, ...(params ? [params] : [])] as const;
};

export const getFindCreatorsQueryOptions = <
  TData = Awaited<ReturnType<typeof findCreators>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: FindCreatorsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findCreators>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getFindCreatorsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof findCreators>>> = ({
    signal,
  }) => findCreators(id, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof findCreators>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type FindCreatorsQueryResult = NonNullable<
  Awaited<ReturnType<typeof findCreators>>
>;
export type FindCreatorsQueryError = ErrorType<unknown>;

/**
 * @summary Search and filter creator roster
 */

export function useFindCreators<
  TData = Awaited<ReturnType<typeof findCreators>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: FindCreatorsParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof findCreators>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getFindCreatorsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Set favorite or hidden status for a creator in a campaign
 */
export const getSetCreatorPreferenceUrl = (id: string, creatorId: string) => {
  return `/api/v1/hiring/campaigns/${id}/creator-preferences/${creatorId}`;
};

export const setCreatorPreference = async (
  id: string,
  creatorId: string,
  setCreatorPreferenceBody: SetCreatorPreferenceBody,
  options?: RequestInit,
): Promise<SetCreatorPreference200> => {
  return customFetch<SetCreatorPreference200>(
    getSetCreatorPreferenceUrl(id, creatorId),
    {
      ...options,
      method: "PUT",
      headers: { "Content-Type": "application/json", ...options?.headers },
      body: JSON.stringify(setCreatorPreferenceBody),
    },
  );
};

export const getSetCreatorPreferenceMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setCreatorPreference>>,
    TError,
    { id: string; creatorId: string; data: BodyType<SetCreatorPreferenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setCreatorPreference>>,
  TError,
  { id: string; creatorId: string; data: BodyType<SetCreatorPreferenceBody> },
  TContext
> => {
  const mutationKey = ["setCreatorPreference"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setCreatorPreference>>,
    { id: string; creatorId: string; data: BodyType<SetCreatorPreferenceBody> }
  > = (props) => {
    const { id, creatorId, data } = props ?? {};

    return setCreatorPreference(id, creatorId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetCreatorPreferenceMutationResult = NonNullable<
  Awaited<ReturnType<typeof setCreatorPreference>>
>;
export type SetCreatorPreferenceMutationBody =
  BodyType<SetCreatorPreferenceBody>;
export type SetCreatorPreferenceMutationError = ErrorType<unknown>;

/**
 * @summary Set favorite or hidden status for a creator in a campaign
 */
export const useSetCreatorPreference = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setCreatorPreference>>,
    TError,
    { id: string; creatorId: string; data: BodyType<SetCreatorPreferenceBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof setCreatorPreference>>,
  TError,
  { id: string; creatorId: string; data: BodyType<SetCreatorPreferenceBody> },
  TContext
> => {
  return useMutation(getSetCreatorPreferenceMutationOptions(options));
};

/**
 * @summary Send offer to a creator
 */
export const getSendOfferUrl = (id: string) => {
  return `/api/v1/hiring/campaigns/${id}/send`;
};

export const sendOffer = async (
  id: string,
  sendOfferBody: SendOfferBody,
  options?: RequestInit,
): Promise<Offer> => {
  return customFetch<Offer>(getSendOfferUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(sendOfferBody),
  });
};

export const getSendOfferMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendOffer>>,
    TError,
    { id: string; data: BodyType<SendOfferBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendOffer>>,
  TError,
  { id: string; data: BodyType<SendOfferBody> },
  TContext
> => {
  const mutationKey = ["sendOffer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendOffer>>,
    { id: string; data: BodyType<SendOfferBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendOffer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendOffer>>
>;
export type SendOfferMutationBody = BodyType<SendOfferBody>;
export type SendOfferMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Send offer to a creator
 */
export const useSendOffer = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendOffer>>,
    TError,
    { id: string; data: BodyType<SendOfferBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendOffer>>,
  TError,
  { id: string; data: BodyType<SendOfferBody> },
  TContext
> => {
  return useMutation(getSendOfferMutationOptions(options));
};

/**
 * @summary Send offers to multiple creators in one request
 */
export const getSendBulkOffersUrl = (id: string) => {
  return `/api/v1/hiring/campaigns/${id}/send-bulk`;
};

export const sendBulkOffers = async (
  id: string,
  bulkSendOffersBody: BulkSendOffersBody,
  options?: RequestInit,
): Promise<BulkSendOffersResult> => {
  return customFetch<BulkSendOffersResult>(getSendBulkOffersUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(bulkSendOffersBody),
  });
};

export const getSendBulkOffersMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendBulkOffers>>,
    TError,
    { id: string; data: BodyType<BulkSendOffersBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendBulkOffers>>,
  TError,
  { id: string; data: BodyType<BulkSendOffersBody> },
  TContext
> => {
  const mutationKey = ["sendBulkOffers"];
  const { mutation: mutationOptions, request: requestOptions } = options ?? {};

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendBulkOffers>>,
    { id: string; data: BodyType<BulkSendOffersBody> }
  > = ({ id, data }) => {
    return sendBulkOffers(id, data, requestOptions);
  };

  return { mutationKey, mutationFn, ...mutationOptions };
};

export type SendBulkOffersMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendBulkOffers>>
>;
export type SendBulkOffersMutationBody = BodyType<BulkSendOffersBody>;
export type SendBulkOffersMutationError = ErrorType<ErrorResponse>;

export const useSendBulkOffers = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendBulkOffers>>,
    TError,
    { id: string; data: BodyType<BulkSendOffersBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendBulkOffers>>,
  TError,
  { id: string; data: BodyType<BulkSendOffersBody> },
  TContext
> => {
  return useMutation(getSendBulkOffersMutationOptions(options));
};

/**
 * @summary Update offer pipeline fields
 */
export const getUpdateOfferUrl = (id: string) => {
  return `/api/v1/hiring/offers/${id}`;
};

export const updateOffer = async (
  id: string,
  updateOfferBody: UpdateOfferBody,
  options?: RequestInit,
): Promise<Offer> => {
  return customFetch<Offer>(getUpdateOfferUrl(id), {
    ...options,
    method: "PATCH",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(updateOfferBody),
  });
};

export const getUpdateOfferMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOffer>>,
    TError,
    { id: string; data: BodyType<UpdateOfferBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateOffer>>,
  TError,
  { id: string; data: BodyType<UpdateOfferBody> },
  TContext
> => {
  const mutationKey = ["updateOffer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateOffer>>,
    { id: string; data: BodyType<UpdateOfferBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return updateOffer(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateOffer>>
>;
export type UpdateOfferMutationBody = BodyType<UpdateOfferBody>;
export type UpdateOfferMutationError = ErrorType<unknown>;

/**
 * @summary Update offer pipeline fields
 */
export const useUpdateOffer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateOffer>>,
    TError,
    { id: string; data: BodyType<UpdateOfferBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateOffer>>,
  TError,
  { id: string; data: BodyType<UpdateOfferBody> },
  TContext
> => {
  return useMutation(getUpdateOfferMutationOptions(options));
};

/**
 * @summary Resend email for an existing offer
 */
export const getResendOfferUrl = (id: string) => {
  return `/api/v1/hiring/offers/${id}/resend`;
};

export const resendOffer = async (
  id: string,
  options?: RequestInit,
): Promise<ResendResult> => {
  return customFetch<ResendResult>(getResendOfferUrl(id), {
    ...options,
    method: "POST",
  });
};

export const getResendOfferMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendOffer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof resendOffer>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ["resendOffer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof resendOffer>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return resendOffer(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type ResendOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof resendOffer>>
>;

export type ResendOfferMutationError = ErrorType<unknown>;

/**
 * @summary Resend email for an existing offer
 */
export const useResendOffer = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof resendOffer>>,
    TError,
    { id: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof resendOffer>>,
  TError,
  { id: string },
  TContext
> => {
  return useMutation(getResendOfferMutationOptions(options));
};

/**
 * @summary Send a follow-up email to one or all creators in a campaign
 */
export const getSendFollowUpUrl = (id: string) => {
  return `/api/v1/hiring/campaigns/${id}/follow-up`;
};

export const sendFollowUp = async (
  id: string,
  followUpBody: FollowUpBody,
  options?: RequestInit,
): Promise<SendFollowUp200> => {
  return customFetch<SendFollowUp200>(getSendFollowUpUrl(id), {
    ...options,
    method: "POST",
    headers: { "Content-Type": "application/json", ...options?.headers },
    body: JSON.stringify(followUpBody),
  });
};

export const getSendFollowUpMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendFollowUp>>,
    TError,
    { id: string; data: BodyType<FollowUpBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof sendFollowUp>>,
  TError,
  { id: string; data: BodyType<FollowUpBody> },
  TContext
> => {
  const mutationKey = ["sendFollowUp"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof sendFollowUp>>,
    { id: string; data: BodyType<FollowUpBody> }
  > = (props) => {
    const { id, data } = props ?? {};

    return sendFollowUp(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SendFollowUpMutationResult = NonNullable<
  Awaited<ReturnType<typeof sendFollowUp>>
>;
export type SendFollowUpMutationBody = BodyType<FollowUpBody>;
export type SendFollowUpMutationError = ErrorType<unknown>;

/**
 * @summary Send a follow-up email to one or all creators in a campaign
 */
export const useSendFollowUp = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof sendFollowUp>>,
    TError,
    { id: string; data: BodyType<FollowUpBody> },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof sendFollowUp>>,
  TError,
  { id: string; data: BodyType<FollowUpBody> },
  TContext
> => {
  return useMutation(getSendFollowUpMutationOptions(options));
};

/**
 * @summary Get offer details by acceptance token (public)
 */
export const getGetAcceptPageUrl = (token: string) => {
  return `/api/v1/hiring/accept/${token}`;
};

export const getAcceptPage = async (
  token: string,
  options?: RequestInit,
): Promise<AcceptDetail> => {
  return customFetch<AcceptDetail>(getGetAcceptPageUrl(token), {
    ...options,
    method: "GET",
  });
};

export const getGetAcceptPageQueryKey = (token: string) => {
  return [`/api/v1/hiring/accept/${token}`] as const;
};

export const getGetAcceptPageQueryOptions = <
  TData = Awaited<ReturnType<typeof getAcceptPage>>,
  TError = ErrorType<ErrorResponse>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAcceptPage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAcceptPageQueryKey(token);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAcceptPage>>> = ({
    signal,
  }) => getAcceptPage(token, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: !!token,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getAcceptPage>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetAcceptPageQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAcceptPage>>
>;
export type GetAcceptPageQueryError = ErrorType<ErrorResponse>;

/**
 * @summary Get offer details by acceptance token (public)
 */

export function useGetAcceptPage<
  TData = Awaited<ReturnType<typeof getAcceptPage>>,
  TError = ErrorType<ErrorResponse>,
>(
  token: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof getAcceptPage>>,
      TError,
      TData
    >;
    request?: SecondParameter<typeof customFetch>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetAcceptPageQueryOptions(token, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Accept an offer (public)
 */
export const getAcceptOfferUrl = (token: string) => {
  return `/api/v1/hiring/accept/${token}`;
};

export const acceptOffer = async (
  token: string,
  options?: RequestInit,
): Promise<AcceptDetail> => {
  return customFetch<AcceptDetail>(getAcceptOfferUrl(token), {
    ...options,
    method: "POST",
  });
};

export const getAcceptOfferMutationOptions = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptOffer>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof acceptOffer>>,
  TError,
  { token: string },
  TContext
> => {
  const mutationKey = ["acceptOffer"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof acceptOffer>>,
    { token: string }
  > = (props) => {
    const { token } = props ?? {};

    return acceptOffer(token, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type AcceptOfferMutationResult = NonNullable<
  Awaited<ReturnType<typeof acceptOffer>>
>;

export type AcceptOfferMutationError = ErrorType<ErrorResponse>;

/**
 * @summary Accept an offer (public)
 */
export const useAcceptOffer = <
  TError = ErrorType<ErrorResponse>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof acceptOffer>>,
    TError,
    { token: string },
    TContext
  >;
  request?: SecondParameter<typeof customFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof acceptOffer>>,
  TError,
  { token: string },
  TContext
> => {
  return useMutation(getAcceptOfferMutationOptions(options));
};
